import type { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import { client } from '../common';

export type ExtensionOption = {
  name: string;
  hours: number;
  available: boolean;
  dailyRate: number;
  discountedDailyRate: number;
  newEndTime: string;
};

type Variables = { id: number };
export type AvailbleExtensionsResponse = {
  nextTrip: { startTime: string; endTime: string } | null;
  quickExtensionOptions: ExtensionOption[];
  hoursBetweenTrips: number;
};

export const useAvailableExtensions = createQuery<
  AvailbleExtensionsResponse,
  Variables,
  AxiosError
>({
  queryKey: ['available-extensions'],
  fetcher: ({ id }) => {
    return client
      .get(`v2/reservations/${id}/available-extensions`)
      .then((response) => {
        return response.data.data;
      });
  },
});
